var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRelatorios = function SvgRelatorios(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 28,
    y: 4,
    fill: "#FF8C54",
    rx: 2.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    d: "M26.5 5.883L21.65.5H6.676C6.038.5 5.5 1.098 5.5 1.86v24.314c.016.748.549 1.326 1.175 1.326h18.65c.626 0 1.16-.578 1.175-1.315V5.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3DD",
    fillRule: "nonzero",
    stroke: "#D2D3DD",
    d: "M21.242 1.044a.14.14 0 0 0-.242.102v4.438a.402.402 0 0 0 .414.408h4.39a.148.148 0 0 0 .095-.28l-4.657-4.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7B8E",
    d: "M8 24h16v1H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D01E29",
    d: "M13 12v12h-3V12h3zm10-2v14h-3V10h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8C54",
    d: "M15 16h3v8h-3z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRelatorios, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/relatorios.f8b87556.svg";
export { ForwardRef as ReactComponent };